import React, { Component } from "react";

import axios from "../../../../configAxios";

import CardHeader from "../../CardHeader";
import MembersGraph from "./MembersGraph";

import Spinner from "../../../../assests/images/spinner.gif";

class Members extends Component {
  signal = axios.CancelToken.source();
  state = {
    loading: true,
    data: []
  };

  componentDidMount() {
    axios.get('/users/stat', { cancelToken: this.signal.token })
      .then(res => {
        this.setState({
          ...this.state,
          data: res.data.json.data.reverse().map(data => {
            return {
              month: data.month,
              newly_registered_users: data.newly_registered_users,
              active_members: data.total
            }
          }),
          loading: false
        })
        this.props.updateGrid();
      })
      .catch(error => error)
  }

  componentWillUnmount() {
    this.signal.cancel('Request is being Cancelled');
  }

  render() {
    const spinner = (
      <img
        src={Spinner}
        style={{ width: "100px", margin: "auto", display: "block" }}
        alt="Loading..."
      />
    );
    return (
      <div className="dashboard">
        <div className="card">
          {this.state.loading ? (
            <div className="card-body p-0">
              <div className="card-text">
                <div className="spinner">{spinner}</div>
              </div>
            </div>
          ) : (
              <React.Fragment>
                <CardHeader
                  title="Members"
                  icon="fa-users"
                  collapse="membersgraph"
                  updateGrid={this.props.updateGrid}
                  removeModule={this.props.removeModule}
                  name={this.props.name} />
                <div className="dashboard-card collapse show" id="membersgraph">
                  <div className="card-body">
                    <div className="card-text" style={{ height: '300px' }}>
                      <MembersGraph data={this.state.data} />
                    </div>
                  </div>
                </div>
              </React.Fragment>
            )}
        </div>
      </div>
    );
  }
}

export default Members;
